export var VideoObjectFit;
(function (VideoObjectFit) {
    VideoObjectFit["COVER"] = "cover";
    VideoObjectFit["CONTAIN"] = "contain";
})(VideoObjectFit || (VideoObjectFit = {}));
export var ColumnCameraWidth;
(function (ColumnCameraWidth) {
    ColumnCameraWidth["FULL_WIDTH"] = "full";
    ColumnCameraWidth["MEDIUM_WIDTH"] = "medium";
    ColumnCameraWidth["SMALL_WIDTH"] = "small";
})(ColumnCameraWidth || (ColumnCameraWidth = {}));
export var ColumnCameraPosition;
(function (ColumnCameraPosition) {
    ColumnCameraPosition["LEFT"] = "left";
    ColumnCameraPosition["TOP"] = "top";
    ColumnCameraPosition["BOTTOM"] = "bottom";
})(ColumnCameraPosition || (ColumnCameraPosition = {}));
